import React, { PureComponent } from 'react';

class BrandGroup extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            selected: false,
            finished: false
        };
    }

    componentDidUpdate() {
        if (this.props.brandIndices && this.props.brandIndices.indexOf(this.props.index) < 0){
            this.setState({ selected: false })
        }else{
            this.setState({ selected: true })
        }
    }

    handleSelect = () => {
        if (!this.state.selected) this.props.addItem({ index: this.props.index, value: this.props.block.title })
        else this.props.removeItem({ index: this.props.index, value: this.props.block.title });
        this.setState({ selected: !this.state.selected });
    }


    render() {
        if (this.props.noPref) {
            return(
                <div 
                    className={this.state.selected ? "no-pref brands-block selected" : "no-pref brands-block"}  
                    onClick={ this.handleSelect }
                >
                    <div className="title">I don’t have a preference</div>
                </div>
            );
        } else {
            return(
                <div 
                    style={ (this.props.index) % 4 === 0 ? { 'marginRight': 0 } : null }
                    className={this.state.selected ? this.props.block.title.toLowerCase().replace("brands", "").trim().replace(" ", "-") + " brands-block selected" : this.props.block.title.toLowerCase().replace("brands", "").trim().replace(" ", "-") + " brands-block"}  
                    onClick={ this.handleSelect }
                >
                    <div className="title">{ this.props.block.title }</div>
                    <div className="image-blocks">
                        { this.props.imageRender }
                    </div>
                </div>
            );
        }
    }
}

export default BrandGroup;



// WEBPACK FOOTER //
// ./src/components/onboarding/BrandGroup.js